import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { insertInlineImage, insertPlaceHolderImage, removePlaceHolderImage } from './ImageUtils'
import { Button, Tooltip } from 'reactstrap'
import { FaImage } from 'react-icons/lib/fa'
import styles from './ImageSlatePlugin.scss'
import AlertContainer from 'react-alert'
import { alertOptions } from '../../constants'
import FileGallerySlateButton from '../FileGallerySlateButton'
import ImageUrlModal from '../ImageUrlModal'
import Upload from '../Upload'

const TooltipContent = props => {
  if (props.uploadState === 'uploading') {
    return <div>Uploading ...</div>
  }

  const style = {
    padding: '5px 10px'
  }
  return <div>
    <div>Image</div>
    <div style={style}><Button onClick={props.onUpload}>Upload</Button></div>
    <div style={style}><Button onClick={props.onGallery}>Gallery</Button></div>
    <div style={{...style, display: 'none'}}><Button onClick={props.onUrl}>URL</Button></div>
  </div>
}

TooltipContent.propTypes = {
  uploadState: PropTypes.string,
  onUpload: PropTypes.func,
  onGallery: PropTypes.func,
  onUrl: PropTypes.func
}

class ImageButton extends Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false,
      progress: 0,
      uploadState: 'default',
      urlModalIsOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  onClick = e => {
    this.onUpload()
  }

  onUpload = e => {
    this.input.click()
  }

  onGallery = e => {
    this.galleryButton.click()
  }

  onStart = () => {
    const { state, onChange } = this.props
    this.setState({
      uploadState: 'uploading',
      progress: 0
    })
    this.props.setEditorReadOnly(true)
    onChange(insertPlaceHolderImage({ state }))
  }

  onFinish = file => {
    const src = file.location
    const fileId = file.id
    const img = new Image()
    img.onload = () => {
      const { state, onChange } = this.props
      onChange(removePlaceHolderImage({ state }))
      this.insertInline({ src, fileId })
    }
    img.onerror = () => {
      const msg = <div>Successful upload but <a target='_blank' href={src}>bad image URL</a></div>
      console.info('Bad Image URL: ' + src)
      this.msg.show(msg, { type: 'error', time: 12000 })
    }
    img.src = src
    this.props.setEditorReadOnly(false)
    this.setState({ progress: 0, uploadState: 'default' })
  }

  onSelectGallery = (e, file) => {
    this.onInsertSrc({ src: file.location, id: file.id })
  }

  onSelectUrl = ({ src }) => {
    this.onInsertSrc({ src })
  }

  onInsertSrc = ({src, id}) => {
    this.onStart()
    this.onFinish({location: src, id})
  }

  insertInline = ({src, fileId}) => {
    const { state, onChange } = this.props
    onChange(insertInlineImage({ state, src, fileId }))
  }

  onError = error => {
    this.props.setEditorReadOnly(false)
    this.setState({ progress: 0, uploadState: 'default' })
    console.info(error)
    throw new Error(error.message)
  }

  getGalleryClick = onClick => {
    this.onGallery = onClick
  }

  toggleUrlModal = () => {
    this.setState({
      urlModalIsOpen: !this.state.urlModalIsOpen
    })
  }

  onClickUrl = e => {
    this.toggleUrlModal()
  }

  render () {
    const { style, noTooltip } = this.props
    const { uploadState, tooltipOpen } = this.state
    const isOpen = tooltipOpen || uploadState === 'uploading'

    const customStyle = {
      position: 'relative'
    }

    const tooltip = (
        !noTooltip &&
        <Tooltip placement='top'
          isOpen={isOpen}
          target={'ImageButton' + this.uid}
          toggle={this.toggle}
          autohide={false}
          >

          <TooltipContent
            uploadState={uploadState}
            onUpload={this.onUpload}
            onGallery={this.onGallery}
            onUrl={this.onClickUrl}
             />
        </Tooltip>
      )

    return (
      <Button id={'ImageButton' + this.uid} style={{...style, ...customStyle}}
        onClick={this.onClick} color={'secondary'}
        className={styles.ImageButton} >
        <FaImage />
        {tooltip}
        <AlertContainer ref={a => (this.msg = a)} {...alertOptions} />

        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: `${this.state.progress}%`,
          opacity: 0.4,
          backgroundColor: !this.state.error ? '#000' : '#92063E'
        }} />

        <Upload
          getRef={input => { this.input = input }}
          accept='image/*'
          onFinish={this.onFinish}
          onStart={this.onStart}
          onError={this.onError}
          hide
          />

        <FileGallerySlateButton
          match={this.props.match}
          history={this.props.history}
          state={this.props.state}
          onChange={this.props.onChange}
          getClick={this.getGalleryClick}
          onSelect={this.onSelectGallery}
          filters={{type: 'image'}}
          hide
          />

        <ImageUrlModal
          isOpen={this.state.urlModalIsOpen}
          toggle={this.toggleUrlModal}
          onSelect={this.onSelectUrl}
          />
      </Button>
    )
  }
}

ImageButton.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  setEditorReadOnly: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default ImageButton

// <ImageGallerySlateButton
//   match={this.props.match}
//   history={this.props.history}
//   state={this.props.state}
//   onChange={this.props.onChange}
//   getClick={this.getGalleryClick}
//   hide
//   />



// WEBPACK FOOTER //
// ./src/components/ImageSlatePlugin/ImageButton.js